/**
 * Created by andrey on 27.01.2021.
 */

const HeroIcon = cc.Node.extend({
    ctor: function (unit) {
        this._super();
        this.unit = unit;

        const styles = cleverapps.styles.HeroIcon;

        const background = this.background = new cc.Sprite(bundles.unitslibrarywindow.frames.hero_background_unavailable);
        background.setScale(styles.background.scale);
        background.setAlignment(styles.background);

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(background.width * background.scaleX, background.height * background.scaleY);
        this.addChild(background);

        const icon = this.icon = new cc.Sprite(bundles.unitslibrarywindow.frames[this.unit.unknownHero ? "icon_unknown" : `icon_${this.unit.code}`]);
        icon.setAlignment(this.unit.unknownHero ? styles.icon_unknown : styles.icon);
        icon.setScale(styles.icon.scale);
        this.addChild(icon);

        this.setCascadeOpacityEnabled(true);
        this.setCascadeColorEnabled(true);
    },

    updateState: function () {
        if (!this.unit.unknownHero && cleverapps.unitsLibrary.hasFresh(this.unit.code)) {
            this.showAttention();
        } else {
            this.hideAttention();
        }

        this.setOpened(!this.unit.unknownHero && cleverapps.unitsLibrary.isOpened(this.unit));
    },

    showAttention: function () {
        const styles = cleverapps.styles.HeroIcon.attention;
        if (this.attention && styles) {
            this.attention.setAlignment(styles);
            return;
        }

        this.attention = new Attention();
        this.attention.setAlignment(styles);
        this.addChild(this.attention);
    },

    hideAttention: function () {
        if (this.attention) {
            this.attention.runAction(new cc.Sequence(
                new cc.ScaleTo(0.15, 0),
                new cc.RemoveSelf()
            ));
            this.attention = undefined;
        }
    },

    showSelection: function () {
        const styles = cleverapps.styles.HeroIcon.selection;

        if (this.selection) {
            this.selection.setAlignment(styles);
            return;
        }

        this.selection = new cc.Sprite(bundles.unitslibrarywindow.frames.hero_background_selected);
        this.selection.setAlignment(styles);
        this.selection.setLocalZOrder(-1);
        this.addChild(this.selection);
    },

    setOpened: function (opened) {
        if (opened) {
            this.background.setSpriteFrame(bundles.unitslibrarywindow.frames.hero_background);
            cleverapps.UI.convertToGrayShape(this.icon, true);

            if (this.checkmark) {
                this.checkmark.setVisible(true);
            }
        } else {
            this.background.setSpriteFrame(bundles.unitslibrarywindow.frames.hero_background_unavailable);

            if (!this.unit.unknownHero) {
                cleverapps.UI.convertToGrayShape(this.icon);
            }

            if (this.checkmark) {
                this.checkmark.setVisible(false);
            }
        }
    }
});

cleverapps.styles.HeroIcon = {
    icon: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 12 },
        scale: 1
    },

    icon_unknown: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 }
    },

    background: {
        x: { align: "center" },
        y: { align: "center" },
        scale: 1
    },

    attention: {
        x: { align: "left", dx: 20 },
        y: { align: "bottom", dy: 20 }
    },

    selection: {
        x: { align: "center" },
        y: { align: "center" }
    }
};
